/**
 * Copyright (c) 2022 Animation Studio Voronezh.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Animation Studio Voronezh.
 */

import defaultRequest from ".";
import permissionNames from "../../constants/permissions";
import getObjectByArrayId from "../../functions/getObjectByArrayId";
import getObjectById from "../../functions/getObjectById";

const preparePermissions = (data) => {
    if (data.roles.length === 0) {
        return {};
    }

    const role = data.roles[0];

    const {
        entity: { ...ENTITY },
        advanced: { ...ADVANCED },
    } = permissionNames;

    const entityPermissions = getObjectByArrayId(
        data.entity_permissions,
        role.entity_permissions
    );

    const preparedEntityPermissions = entityPermissions.reduce(
        (entityPermissionsObject, permission) => {
            const entity = getObjectById(
                data.entity_types,
                permission.entity_type
            );

            entityPermissionsObject[entity.model] = {
                [ENTITY.CAN_SEE]: permission.see,
                [ENTITY.CAN_CREATE]: permission.create,
                [ENTITY.CAN_EDIT]: permission.edit,
                [ENTITY.CAN_DELETE]: permission.delete,
                [ENTITY.CAN_EDIT_ONLY_OWN]: permission.edit_only_own,
            };
            return entityPermissionsObject;
        },
        {}
    );

    const advancedPermissions = getObjectById(
        data.advanced_permissions,
        role.advanced_permissions
    );

    const {
        access_admin_functionality,
        see_all_pages,
        see_all_projects,
        set_defaults_for_project_pages_and_entity_detail_pages,
        show_and_edit_webhooks,
        can_write_to_freelancers,
    } = advancedPermissions;

    const preparedAdvancedPermissions = {
        [ADVANCED.CAN_ACCESS_ADMIN]: access_admin_functionality,
        [ADVANCED.CAN_SEE_ALL_PAGES]: see_all_pages,
        [ADVANCED.CAN_SEE_ALL_PROJECTS]: see_all_projects,
        [ADVANCED.CAN_SET_DEFAULT]: set_defaults_for_project_pages_and_entity_detail_pages,
        [ADVANCED.CAN_EDIT_WEBHOOKS]: show_and_edit_webhooks,
        [ADVANCED.CAN_WRITE_TO_FREELANCERS]: can_write_to_freelancers,
    };

    return {
        entity: preparedEntityPermissions,
        advanced: preparedAdvancedPermissions,
    };
};

export const userRoleApi = {
    loadUserRole: async (params = {}) => {
        const result = await defaultRequest.get("/api/v1/user_role", {
            params: {
                ...params,
                include: [
                    "entity_permissions.*",
                    "field_permissions.*",
                    "advanced_permissions.*",
                    "entity_permissions.entity_type.*",
                    "field_permissions.entity_type.*",
                ],
            },
        });
        const data = await result.data;
        return preparePermissions(data);
    },
};
